export const PaymentLogs = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.27539 9.31472H20.7299M5.96071 14.014H11.3313M5.96071 16.028H8.64602M5.28938 18.7133H18.716C19.2501 18.7133 19.7624 18.5011 20.1401 18.1234C20.5178 17.7457 20.7299 17.2335 20.7299 16.6993V7.30073C20.7299 6.76659 20.5178 6.25432 20.1401 5.87663C19.7624 5.49893 19.2501 5.28674 18.716 5.28674H5.28938C4.75523 5.28674 4.24297 5.49893 3.86527 5.87663C3.48758 6.25432 3.27539 6.76659 3.27539 7.30073V16.6993C3.27539 17.2335 3.48758 17.7457 3.86527 18.1234C4.24297 18.5011 4.75523 18.7133 5.28938 18.7133Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};